import fetch from "auth/FetchInterceptor";

const RoomsService = {};

const roomsEndpointPrefix = "/salle";

RoomsService.getRooms = async () =>
    await fetch(`${roomsEndpointPrefix}/getAll`, {
        method: "GET",
    });

RoomsService.getRoomById = async (id) =>
    await fetch(`${roomsEndpointPrefix}/getById/${id}`, {
        method: "GET",
    });

RoomsService.createRoom = async (data) =>
    await fetch(`${roomsEndpointPrefix}/create`, {
        data,
        method: "POST",
    });

RoomsService.updateRoom = async (id, data) =>
    await fetch(`${roomsEndpointPrefix}/update/${id}`, {
        data,
        method: "PUT",
    });

RoomsService.deleteRoomById = async (id) =>
    await fetch(`${roomsEndpointPrefix}/deleteById/${id}`, {
        method: "DELETE",
    });

export default RoomsService;
